module.exports = __webpack_public_path__ + "static/media/BoxPlotQ7_3.867116f3.svg";